import RTKQueryError from '../RTKQueryError';

export default class AtlasQueryError extends RTKQueryError {
  constructor(...args) {
    super(...args);
    this.name = 'AtlasQueryError';
  }
}
